export default __webpack_public_path__ + "static/media/gate.io.0d3c4cd6.svg";